import {
    Col,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "reactstrap";
const PackageViewModal = ({ isOpen, toggle, data }) => {
    if (!data) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
            <ModalHeader toggle={toggle}>تفاصيل الباقة</ModalHeader>

            <ModalBody>
                <Row>
                    <Col md={4} className="text-center mb-3">
                        <img
                            src={data.icon}
                            alt="package"
                            style={{
                                width: "100%",
                                borderRadius: 10,
                                maxHeight: 200,
                                objectFit: "cover",
                            }}
                        />
                    </Col>

                    <Col md={8}>
                        <div className="mb-3">
                            <strong>اسم الباقة:</strong> {data.name}
                        </div>

                        <div className="mb-3">
                            <strong>عدد الكوينز:</strong> {data.coins}
                        </div>

                        <div className="mb-3">
                            <strong>السعر:</strong> {data.price} ج.م
                        </div>

                        <div className="mb-3">
                            <strong>ترتيب العرض:</strong> {data.sortOrder}
                        </div>

                        <div className="mb-3">
                            <strong>الحالة:</strong>{" "}
                            <span
                                className={`badge ${data.isActive ? "bg-success" : "bg-danger"
                                    }`}
                            >
                                {data.isActive ? "مفعلة" : "غير مفعلة"}
                            </span>
                        </div>

                        <div className="mb-3">
                            <strong>مميزة:</strong>{" "}
                            <span
                                className={`badge ${data.isFeatured ? "bg-warning" : "bg-secondary"
                                    }`}
                            >
                                {data.isFeatured ? "نعم" : "لا"}
                            </span>
                        </div>

                        <div className="mb-3">
                            <strong>تاريخ الإنشاء:</strong>{" "}
                            {new Date(data.createdAt).toLocaleString()}
                        </div>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};


export default PackageViewModal;
